import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Cpu, ChevronRight, Hash } from "lucide-react";
import { http } from "../axios/axios";
import SectionHeader from "./SectionHeader";
import ProductCard from "./ProductCard";

const API_BASE = import.meta.env.API_BASE || "https://api.suraksha24x7.com";

const RelatedProducts = ({ categoryId, catalogType, currentProductId }) => {
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRelated = async () => {
      if (!categoryId) return;

      try {
        const isIpNetwork = catalogType === "ip-network";
        const res = await http.get(`/products`, {
          params: {
            ...(isIpNetwork ? { ipNetworkCategory: categoryId } : { category: categoryId }),
            catalogType: isIpNetwork ? "ip-network" : "catalog",
            limit: 8,
            status: "Published",
          },
        });

        const filteredProducts = res.data.product.filter(
          (item) => item._id !== currentProductId,
        );

        setRelated(filteredProducts);
      } catch (err) {
        console.error("Sync Error: Related Assets");
      } finally {
        setLoading(false);
      }
    };

    fetchRelated();
  }, [categoryId, catalogType, currentProductId]);

  if (loading || related.length === 0) return null;

  return (
    <section className="mt-16 border-t border-slate-100 pt-12">
      {/* HEADER (clean integration) */}
      <SectionHeader
        badge="Security Ecosystem"
        title="Related Infrastructure"
        description="Similar devices from the same category and deployment layer."
        showLine={true}
        action={
          <Link
            to="/security-product"
            className="
                    group
        inline-flex
        items-center
        gap-2
        text-sm
        font-semibold
        text-slate-700
        hover:text-blue-600
        transition-colors
            
            "
          >
            View All Products
            <ArrowRight size={14} />
          </Link>
        }
      />

      {/* GRID */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {related.map((item) => (
          <ProductCard key={item._id} item={item} />
        ))}
      </div>
    </section>
  );
};

export default RelatedProducts;
